import { useState } from "react";
import { Plus, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "@/section/router";
import { TemplateListSection } from "../TemplateList";
import { SendAchFormModal } from "../components/SendAchFormModal";

export function AchTemplatesPage() {
  const navigate = useNavigate();
  const [isSendFormModalOpen, setIsSendFormModalOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm text-muted-foreground uppercase tracking-wide">
            ACH
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => setIsSendFormModalOpen(true)}>
            <Send className="mr-2 h-4 w-4" />
            Send Form
          </Button>
          <Button onClick={() => navigate(RoutePath.AchDocumentsTemplatesCreate)}>
            <Plus className="mr-2 h-4 w-4" />
            Create Template
          </Button>
        </div>
      </div>

      <TemplateListSection />

      <SendAchFormModal
        open={isSendFormModalOpen}
        onOpenChange={setIsSendFormModalOpen}
        onSuccess={() => {
          setIsSendFormModalOpen(false);
        }}
      />
    </div>
  );
}




